import { createRouter, createWebHistory } from 'vue-router'

// Importación de vistas
import WebDevelopment from '../views/WebDevelopment.vue'
import Associates from '../views/Associates.vue'
import Blog from '../views/Blog.vue'

import WebProfesional from '../blog/WebProfesional.vue'
import WebVsTiendaNube from '../blog/WebVsTiendaNube.vue'
import Seo from '../blog/Seo.vue'
import MantenimientoWeb from '../blog/MantenimientoWeb.vue'
import OptimizacionPosicionamiento from '../blog/OptimizacionPosicionamiento.vue'
import PresenciaOnlineLocales from '../blog/PresenciaOnlineLocales.vue'

const routes = [
  {
    path: '/',
    name: 'WebDevelopment',
    component: WebDevelopment
  },
  {
    path: '/associates',
    name: 'Associates',
    component: Associates
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/blog/sitioweb-profesional',
    name: 'WebProfesional',
    component: WebProfesional
  },
  {
    path: '/blog/webprogramada-vs-constructores',
    name: 'WebVsTiendaNube',
    component: WebVsTiendaNube
  },
  {
    path: '/blog/seo',
    name: 'Seo',
    component: Seo
  },
  {
    path: '/blog/mantenimientoweb',
    name: 'MantenimientoWeb',
    component: MantenimientoWeb
  },
  {
    path: '/blog/optimizacion-posicionamiento',
    name: 'OptimizacionPosicionamiento',
    component: OptimizacionPosicionamiento
  },
  {
    path: '/blog/presencia-online',
    name: 'PresenciaOnlineLocales',
    component: PresenciaOnlineLocales
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const el = document.getElementById(to.hash.slice(1))
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' })
            resolve({ el }) // Vue Router sabe que ya hizo scroll
          } else {
            resolve(savedPosition || { top: 0 })
          }
        }, 500) // Esperamos un poco más para que el DOM esté listo
      })
    }
    return { top: 0 }
  }
})

export default router
